import { render } from "./ServicesFrontCard.vue?vue&type=template&id=611d8458&scoped=true&ts=true"
import script from "./ServicesFrontCard.vue?vue&type=script&lang=ts"
export * from "./ServicesFrontCard.vue?vue&type=script&lang=ts"

import "./ServicesFrontCard.vue?vue&type=style&index=0&id=611d8458&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-611d8458"]])

export default __exports__